$(document).ready(function() {
    // Check if the 'loadingShown' cookie exists
    if (typeof Cookies.get('loadingShown') === 'undefined') {
        $('#loading-section').show();

        // Set the cookie to expire in 1 day
        Cookies.set('loadingShown', 'true', { expires: 1 });
    } else {
        // Hide loading section if cookie exists
        $('#loading-section').hide();
    }
});

gsap.from(".custom-h2 div", 1.5, {
    yPercent: 120,
    ease: "power4.inOut",
    stagger: {
        amount: 0.5,
    },
});

gsap.to(".custom-h2", 1.5, {
    clipPath:"polygon(0 0 , 100% 0 , 100% 100%, 0 100%)",
    ease:"power4.inOut",
    stagger:{
        amount:0.5,
    },
});

document.addEventListener("DOMContentLoaded", function() {
    let overlay = document.querySelector(".custom-overlay");
    
    overlay.addEventListener("click", function() {
        // Ensure loading is complete before executing animations
        if (typeof Cookies.get('loadingShown') !== 'undefined') {
            gsap.to(".custom-h2 div", 1.5, {
                yPercent: -100,
                ease: "power4.inOut",
                stagger: {
                    amount: 0.5,
                },
            });

            gsap.to(".custom-h2", 1.5, {
                clipPath: "polygon(0 85%, 100% 85%, 100% 100%, 0 100%)",
                ease: "power4.inOut",
                stagger: {
                    amount: 0.5,
                },
            });

            gsap.to(".custom-overlay", 2, {
                clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
                ease: "power4.inOut",
            });

            gsap.to(".custom-img", 2, {
                clipPath: "polygon(0 100%, 100% 100%, 100% 0%, 0% 0%)",
                ease: "power4.inOut",
                stagger: {
                    amount: 1.5,
                },
            });

            gsap.to(".custom-loader", 2, {
                clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
                ease: "power4.inOut",
                delay: 2,
            });
        }
    });
});